(function(config) {
    'use strict';

    angular.module('stats.services', [
            'ngResource'
        ])
        .factory('montageStatsDataSrvc', montageStatsDataSrvc)
        .factory('productionStatsDataSrvc', productionStatsDataSrvc)
        .factory('productionLogsDataSrvc', productionLogsDataSrvc)
        .factory('clientStatsDataSrvc', clientStatsDataSrvc)
        .factory('productsStatsDataSrvc', productsStatsDataSrvc)
        .factory('packagesStatsDataSrvc', packagesStatsDataSrvc)
        .factory('previewStatsSrvc', previewStatsSrvc)
        .factory('previewStatsModalSrvc', previewStatsModalSrvc)
        .factory('salesStatsDataSrvc', salesStatsDataSrvc);

    productionLogsDataSrvc.$inject = ['$resource'];

    function productionLogsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/production-logs/:pk/', {pk: '@pk'}, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/production-logs/',
                params: {
                    page: '@page'
                }
            },
            statuses: {
                method: 'GET',
                url: config.api + '/api/v1/production-logs/log_statuses',
                isArray: true
            },
            summary: {
                method: 'GET',
                url: config.api + '/api/v1/production-logs/summary'
            }
        });
    }

    montageStatsDataSrvc.$inject = ['$resource'];

    function montageStatsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/montage-stats/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/montage-stats/',
                params: {
                    page: '@page'
                }
            }
        });
    }

    productionStatsDataSrvc.$inject = ['$resource'];

    function productionStatsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/production-stats/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/production-stats/',
                params: {
                    page: '@page'
                }
            }
        });
    }

    clientStatsDataSrvc.$inject = ['$resource'];

    function clientStatsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/client-stats/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/client-stats/',
                params: {
                    page: '@page'
                }
            },
            clientFavoriteProducts: {
                method: 'GET',
                url: config.api + '/api/v1/client-stats/favorite-products/:pk/',
                isArray: true,
                params: {
                    pk: '@pk'
                },
            },
            shopVersions: {
                method: 'GET',
                url: config.api + '/api/v1/client-stats/shop_versions/',
                isArray: true
            }
        });
    }

    packagesStatsDataSrvc.$inject = ['$resource'];

    function packagesStatsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/packages-stats/:pk/', { pk: '@pk' }, {
            stats: {
                method: 'GET',
                url: config.api + '/api/v1/packages-stats/',
            }
        });
    }

    productsStatsDataSrvc.$inject = ['$resource'];

    function productsStatsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/products-stats/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/products-stats/',
                params: {
                    page: '@page'
                }
            }
        });
    }

    previewStatsModalSrvc.$inject = ['$uibModal'];

    function previewStatsModalSrvc($uibModal) {
        return {
            previewSubsModal: previewSubsModal,
            previewFavoritesModal: previewFavoritesModal,
            previewPackageDaysModal: previewPackageDaysModal
        };

        function previewPackageDaysModal(startDate, endDate, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/stats/views/preview-package-days-modal/preview-package-days-modal.html',
                controller: 'PreviewPackageDaysModalController',
                controllerAs: 'ctrl',
                size: 'l',
                windowClass: 'admin-preview-modal',
                resolve: {
                    startDate: function () {
                        return startDate;
                    },
                    endDate: function() {
                        return endDate;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

        function previewSubsModal(client, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/stats/views/preview-subscriptions-modal/preview-subscriptions-modal.html',
                controller: 'PreviewSubscriptionsModalController',
                controllerAs: 'ctrl',
                size: 'l',
                windowClass: 'admin-preview-modal',
                resolve: {
                    client: function () {
                        return client;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }
        function previewFavoritesModal(client, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/stats/views/preview-favorite-products-modal/preview-favorite-products-modal.html',
                controller: 'PreviewFavoriteProductsModalController',
                controllerAs: 'ctrl',
                size: 'l',
                windowClass: 'admin-preview-modal',
                resolve: {
                    client: function () {
                        return client;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }

    }

    previewStatsSrvc.$inject = ['previewStatsModalSrvc', 'saveFileSrvc', 'webglSrvc'];

    function previewStatsSrvc(previewStatsModalSrvc, saveFileSrvc, webglSrvc) {
        return {
            previewSubscriptions: previewSubscriptions,
            previewFavorites: previewFavorites,
            previewPackageDays: previewPackageDays,
        };

        function previewPackageDays(startDate, endDate) {
            previewStatsModalSrvc.previewPackageDaysModal(startDate, endDate, angular.noop, angular.noop)
        }

        function previewSubscriptions(client) {
            previewStatsModalSrvc.previewSubsModal(client, angular.noop, angular.noop)
        }

        function previewFavorites(client) {
            previewStatsModalSrvc.previewFavoritesModal(client, angular.noop, angular.noop)
        }

    }

    salesStatsDataSrvc.$inject = ['$resource'];

    function salesStatsDataSrvc($resource) {
        return $resource(config.api + '/api/v1/sales-stats/:pk/', { pk: '@pk' }, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/sales-stats/',
                params: {
                    page: '@page'
                }
            },
            shopVersions: {
                method: 'GET',
                url: config.api + '/api/v1/sales-stats/shop_versions/',
                isArray: true
            },
            groupByDatesOptions: {
                method: 'GET',
                url: config.api + '/api/v1/sales-stats/group_by_dates_options/',
                isArray: true
            }
        });
    }

})(window.config);
